"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _sources = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/sources");

var _connectUpgradeData = _interopRequireDefault(require("ui-addon-upgrades/_core/common/data/upgradeData/connectUpgradeData"));

var _CheckoutButton = _interopRequireDefault(require("ui-addon-upgrades/_core/checkout/CheckoutButton"));

var CHECKOUT = _sources.sourceKeys.CHECKOUT;

var _default = (0, _connectUpgradeData.default)(_CheckoutButton.default, CHECKOUT);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/button/UICheckoutButton.js
// module id = 499
// module chunks = 5 6